// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--van-tabbar-height:50px;--van-tabbar-z-index:1;--van-tabbar-background-color:var(--van-background-color-light)}.van-tabbar{z-index:var(--van-tabbar-z-index);display:flex;box-sizing:content-box;width:100%;height:var(--van-tabbar-height);background:var(--van-tabbar-background-color)}.van-tabbar--fixed{position:fixed;bottom:0;left:0}", ""]);
// Exports
module.exports = exports;
